(() => {
  const nodes = document.querySelectorAll(
    "[data-bf-price-cents], [data-bf-compare-cents], [data-bf-save-cents]"
  );
  if (!nodes.length) return;

  const currency = window.Shopify?.currency?.active || "AUD";
  const formatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatCents = (value) => {
    const cents = Number(value);
    return Number.isFinite(cents) ? formatter.format(cents / 100) : value;
  };

  nodes.forEach((node) => {
    const cents =
      node.dataset.bfPriceCents ??
      node.dataset.bfCompareCents ??
      node.dataset.bfSaveCents;
    if (cents !== undefined) node.textContent = formatCents(cents);
  });
})();
